'use strict';
import {getLink} from '../../core-utilities/domain/ReduxUtils';

const angular = require('angular');
const {isArray, noop} = angular;

export const CLASS_NAME = 'TeamDomain';
export const COLLECTION = 'teams';
export const TEAMS_COLLECTION = 'teams';

export function TeamDomainProvider() {
  return {
    $get: [
      'FirebaseUtil',
      'AuthService',
      'AbstractDomainClass',
      'AvatarMixin',
      'OrgMixin',
      'fetchUtils',
      'restUtils',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function (
        FirebaseUtil,
        AuthService,
        AbstractDomainClass,
        AvatarMixin,
        OrgMixin,
        fetchUtils,
        restUtils,
        FirebaseQueueService,
        ROOT_API_COLLECTION,
        ROOT_API_SPEC,
      ) {
        //console.log('Created  TeamDomain');

        function TeamDomain(data) {
          AbstractDomainClass.call(this, TeamDomain, data);
        }

        AbstractDomainClass.__inheritFrom(TeamDomain, CLASS_NAME, COLLECTION);

        TeamDomain.$constraints.addConstraints({
          name: {type: 'string'},
          type: {type: 'Domain', domainClass: 'TeamTypeDomain'},
          description: {type: 'string', widget: 'textarea', nullable: true},
          organization: {type: 'Domain', domainClass: 'OrganizationDomain'},
          createdBy: {type: 'DomainLink', domainClass: 'UserDomain'},
          dateCreated: {type: 'Date'},
          lastUpdated: {type: 'Date'},

          conversation: {type: 'LinkedDocument', domainClass: 'ConversationDomain', link: 'target'},

          members: {
            type: 'DomainCollection',
            domainClass: 'PersonDomain',
            links: 'teams',
            relationClass: 'TeamRoleDomain'
          }
        });

        OrgMixin(TeamDomain);
        AvatarMixin(TeamDomain);

        // more methods go here;

        TeamDomain.prototype.isUser = noop;
        TeamDomain.prototype.getAvatarInitials = getAvatarInitials;
        TeamDomain.prototype.getAvatarIndex = getAvatarIndex;

        TeamDomain.prototype.create = restUtils.createProto(TeamDomain, {
          getBody: data => ({
            name: data.name,
            description: data.description,

            type: getLink(data, 'type').id,
            orgId: getLink(data, 'organization').id,
          }),
        });

        TeamDomain.prototype.update = restUtils.updateProto(TeamDomain);

        // TODO: add support for custom templates. these would presumably be saved against an org so you wouldn't need to pass this here
        TeamDomain.prototype.updateMembers = function updateMembers(toAdd, toRemove) {
          var request = {
            method: 'teams/members/update',
            data: {
              teamId: this.$id,
              add: isArray(toAdd) && toAdd.length ? toAdd : null,
              remove: isArray(toRemove) && toRemove.length ? toRemove : null
            }
          };

          return FirebaseQueueService.addTask(request, AuthService.getUserId(), ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        TeamDomain.isMemberRef = function (teamId, profileId) {
          return FirebaseUtil.firebaseRef([
            TeamDomain.COLLECTION + '-meta',
            teamId,
            'links',
            'members',
            profileId
          ].join('/'));
        };

        TeamDomain.prototype.isMemberRef = function (profileId) {
          return TeamDomain.isMemberRef(this.$id, profileId);
        };

        TeamDomain.prototype.isMember = function (profileId) {
          return FirebaseUtil.read([
            TeamDomain.COLLECTION + '-meta',
            this.$id,
            'links',
            'members',
            profileId
          ].join('/')).then(
            function (relation) {
              return !!relation;
            }, function (err) {
              return false;
            });
        };

        TeamDomain.prototype.getCasualName =
          TeamDomain.prototype.toString =
            function () {
              return this.name;
            };

        function getAvatarInitials() {
          return this.name ? this.name.charAt(0).toUpperCase() : ''; // ternary statement to patch race condition when deleting a team
        }

        function getAvatarIndex() {
          return this.avc;
        }

        return TeamDomain;
      }]
  };
}



// WEBPACK FOOTER //
// ./src/js/personnel/domain/TeamDomain.js